import { render, staticRenderFns } from "./AssessmentEditDialog.vue?vue&type=template&id=26e555f1&"
import script from "./AssessmentEditDialog.vue?vue&type=script&lang=ts&"
export * from "./AssessmentEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports